<template>
    <div>
        <router-view></router-view>
    </div>
</template>

<script>

export default {

	metaInfo: {
		title: "Account invitation"
	},

	components: {

    },

	mounted() {
	},

    props: {

    },

	data: function() {
		return {
		};
	},

    watch: {

    },

    computed: {

    },

    methods: {

    },
}

</script>
